module.exports = __webpack_public_path__ + "img/StatusBar.0b4b3550.png";